// WARNING: DO NOT EDIT.  This file is automatically generated
// Written by aws-amplify-serverless-plugin/1.4.1 on 2026-04-28T14:25:50.968Z

const awsmobile = {
    aws_cloud_logic_custom: [
        {
            endpoint: 'https://jj3q1ijkd3.execute-api.eu-central-1.amazonaws.com/dev',
            name: 'ApiGatewayRestApi',
            region: 'eu-central-1'
        }
    ],
    aws_cognito_identity_pool_id: 'eu-central-1:7691eefa-970d-4452-92df-dd2040fef7de',
    aws_cognito_region: 'eu-central-1',
    aws_project_region: 'eu-central-1',
    aws_user_pools_id: 'eu-central-1_YAtU5xPct',
    aws_user_pools_web_client_id: '6krvdssimirr06c6p8i6udhj46'
};

export default awsmobile;
